import { LibPhoneNumberErrorType } from '../enums';

export const LIB_PHONE_NUMBER_ERROR_TYPES: LibPhoneNumberErrorType[] = [
  LibPhoneNumberErrorType.InvalidCountry,
  LibPhoneNumberErrorType.NotANumber,
  LibPhoneNumberErrorType.NotValid,
  LibPhoneNumberErrorType.TooLong,
  LibPhoneNumberErrorType.TooShort,
];
